export class HTML {
    public static trim(html: string): string {
        html = html.replace(/<\/?[^>]+(>|$)/g, "");
        html = html.replace(/&nbsp;/g, '');
        
        return html;
    }
}